import { useBreakPoints } from 'core';
import { Avatar, Divider, Group, Stack, Text } from 'ui';

import { useGetHolidayPromotion } from '../api';

const Activity = ({
  tagline,
  timeAgo,
  initials,
  name,
}: {
  tagline: string;
  timeAgo: string;
  initials: string;
  name: string;
}) => {
  return (
    <Group align="flex-start" w={'100%'} wrap="nowrap">
      <Avatar color="cobalt">{initials}</Avatar>
      <Stack style={{ flexGrow: 1 }}>
        <Stack gap={0}>
          <Text fz={12} c="gray.6">
            <Text fw={600} span fz={12} c="gray.6">
              {name}{' '}
            </Text>
            {tagline}
          </Text>

          <Text fz={12} c="gray.6">
            {timeAgo}
          </Text>
        </Stack>
        <Divider />
      </Stack>
    </Group>
  );
};

const RecentActivity = () => {
  const { isSmallScreen } = useBreakPoints();
  const { data: data } = useGetHolidayPromotion();

  return (
    <Stack gap={'lg'}>
      <Text fw={600} fz={isSmallScreen ? 18 : 24}>
        Recent Activity
      </Text>

      {data?.recent_activity?.map((promotion) => {
        return (
          <Activity
            key={promotion.uuid}
            tagline={promotion.tagline}
            timeAgo={promotion.time_ago}
            initials={promotion.initials}
            name={promotion.name}
          />
        );
      })}
    </Stack>
  );
};
export { RecentActivity };
